import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function SimpleProcess() {
  const { ref, isVisible } = useScrollReveal();

  const steps = [
    {
      number: "1",
      title: "Submit your Application",
      description: "Fill out a quick form (takes 5 minutes). It's free to apply!",
    },
    {
      number: "2",
      title: "Submit your channels",
      description: "Whitelist your channels and assets for EnfiniShield to protect, manage and enforce your digital rights.",
    },
    {
      number: "3",
      title: "We scan and detect 24/7",
      description: "Our system scans 24/7 to find unauthorized uploads, keeping your content protected at all times.",
    },
    {
      number: "4",
      title: "Recover and Monetize",
      description: "Eligible reuploads are claimed, allowing you to monetize unauthorized use of your content.",
    },
  ];

  return (
    <div
      id="how-it-works"
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } bg-white py-20 lg:py-32 px-4 xxs:px-8 xs:px-10 sm:px-10 md:px-10 lg:px-12 xl:px-12 4xl:px-16`}
    >
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="flex flex-col gap-[30px] items-center text-center mb-16">
          {/* Label */}
          <p className="text-[#757575] text-[18px] xxs:text-[15px] xs:text-[16px] sm:text-[16px] md:text-[16px] lg:text-[18px] 4xl:text-[24px] font-medium">
          Fast, simple, and stress-free
          </p>

          {/* Main Heading */}
          <h1 className="text-5xl xxs:text-5xl xs:text-6xl sm:text-6xl md:text-6xl lg:text-[80px] 4xl:text-[80px] font-normal text-black leading-[106px] xxs:leading-normal xs:leading-normal sm:leading-normal md:leading-normal lg:leading-normal enfinity-header-font" style={{ lineHeight: "1.2" }}>
            <span>Let's protect your account</span>
            <br />
            <span className="text-[#8b5cf6]">in 4 simple steps</span>
          </h1>

          {/* Description */}
          <p className="text-xl xxs:text-[1rem] lg:text-[24px] font-normal text-black leading-[34px] max-w-[716px] enfinity-subtext-font">
            Setting up EnfiniShield is quick and easy. Set it and forget it. We handle everything automatically.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="flex flex-col md:flex-row lg:grid lg:grid-cols-2 lg:gap-[34px] xl:flex xl:flex-row gap-[34px] items-start justify-center">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex flex-col gap-[31px] items-center text-center w-full md:w-[332px] lg:w-auto xl:w-[332px]"
            >
              {/* Numbered Circle */}
              <div className="relative w-[82px] h-[82px] flex items-center justify-center">
                <div className="absolute inset-0 bg-gradient-to-br from-[#8b5cf6] to-[#7336ff] rounded-full" />
                <p className="relative text-[40px] font-extrabold text-white text-center">
                  {step.number}
                </p>
              </div>

              {/* Step Content */}
              <div className="flex flex-col gap-[19px] items-center text-center w-full">
                <p className="text-[24px] font-semibold text-black leading-normal enfinity-header-font">
                  {step.title}
                </p>
                <p className="text-[20px] xxs:text-[1rem] lg:text-lg 4xl:text-[19px] font-normal text-black leading-[34px] enfinity-subtext-font">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

